import { gql } from '@apollo/client'

export const ACCOUNT_BALANCE__GET_BALANCE = gql(/* GraphQL */ `
  query AccountBalance_GetBalance {
    myEnterprise {
      id
      wallet {
        balance {
          available
        }
      }
      subscription {
        ... on BillingSubscriptionActive {
          id
          pastDueInvoice {
            id
            createdAt
            items {
              amount
              description
            }
            authorizedAmount
          }
          plan {
            id
            name
            price
            product {
              isLegacy
            }
          }
          upcomingInvoice {
            paymentDate
            totalAmount
          }
        }
      }
    }
  }
`)
